import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { NbLayoutModule, NbCardModule, NbCheckboxModule } from '@nebular/theme';

import { NbAuthService } from './services';
import { NbDummyAuthProvider } from './providers/dummy-auth.provider';
import { NbEmailPassAuthProvider } from './providers/email-pass-auth.provider';

import {
  defaultSettings,
  NB_AUTH_USER_OPTIONS_TOKEN,
  NB_AUTH_OPTIONS_TOKEN,
  NB_AUTH_PROVIDERS_TOKEN,
  NB_AUTH_TOKEN_WRAPPER_TOKEN,
  NbAuthOptions, NB_AUTH_INTERCEPTOR_HEADER,
} from './auth.options';

import { NbAuthComponent } from './components';
import { NbAuthSimpleToken, NbTokenService } from './services';

import { AuthBlockComponent } from './components';
import { LoginComponent } from './components/login/login.component';

import { routes } from './auth.routes';
import { deepExtend } from './helpers';

import { LoadingService } from './components/loading/loading.service';
import { LoadingComponent } from './components/loading/loading.component';
import { AuthSmagComponent } from './components/auth-smag/auth-smag.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SmagAccountService } from './services/index';


export function nbAuthServiceFactory(config: any, tokenService: NbTokenService, injector: Injector) {
  const providers = config.providers || {};

  for (const key in providers) {
    if (providers.hasOwnProperty(key)) {
      const provider = providers[key];
      const object: any = injector.get(provider.service);
      object.setConfig(provider.config || {});
    }
  }
  return new NbAuthService(tokenService, injector, providers);
}

export function nbOptionsFactory(options) {
  return deepExtend(defaultSettings, options);
}

@NgModule({ declarations: [
        NbAuthComponent,
        AuthBlockComponent,
        LoginComponent,
        LoadingComponent,
        AuthSmagComponent,
    ],
    exports: [
        NbAuthComponent,
        AuthBlockComponent,
        LoginComponent,
        LoadingComponent,
        AuthSmagComponent
    ], imports: [CommonModule,
        NbLayoutModule,
        NbCardModule,
        NbCheckboxModule,
        RouterModule.forChild(routes),
        FormsModule,
        NgbModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })

export class NbAuthModule {
  static forRoot(nbAuthOptions?: NbAuthOptions): ModuleWithProviders<NbAuthModule> {
    return {
      ngModule: NbAuthModule,
      providers: [
        { provide: NB_AUTH_USER_OPTIONS_TOKEN, useValue: nbAuthOptions },
        { provide: NB_AUTH_OPTIONS_TOKEN, useFactory: nbOptionsFactory, deps: [NB_AUTH_USER_OPTIONS_TOKEN] },
        { provide: NB_AUTH_PROVIDERS_TOKEN, useValue: {} },
        { provide: NB_AUTH_TOKEN_WRAPPER_TOKEN, useClass: NbAuthSimpleToken },
        { provide: NB_AUTH_INTERCEPTOR_HEADER, useValue: 'Authorization' },
        {
          provide: NbAuthService,
          useFactory: nbAuthServiceFactory,
          deps: [NB_AUTH_OPTIONS_TOKEN, NbTokenService, Injector],
        },
        NbTokenService,
        NbDummyAuthProvider,
        NbEmailPassAuthProvider,
        LoadingService,
        SmagAccountService
      ],
    };
  }
}
